export default __webpack_public_path__ + "static/media/section_tags_helper.7e0f0018.png";